<router-outlet></router-outlet>
<div class="fixed top-[4%] right-[4%] z-99999">
  @if (updateMessage$ | async; as updateMessage) {
    <fuse-alert [type]="'success'" [appearance]="'outline'"
      [dismissible]="true" [dismissed]="true" [name]="'update-alert'" class="relative">
      <span fuseAlertTitle>Exito</span>
      {{updateMessage}}
    </fuse-alert>
  }
  @if (saveMessage$ | async; as saveMessage) {
    <fuse-alert [type]="'success'" [appearance]="'outline'"
      [dismissible]="true" [dismissed]="true" [name]="'save-alert'" class="relative">
      <span fuseAlertTitle>Exito</span>
      {{saveMessage}}
    </fuse-alert>
  }
  @if (errorMessage$ | async; as errorMessage) {
    <fuse-alert [type]="'error'" [appearance]="'outline'"
      [dismissible]="true" [dismissed]="true" [name]="'error-alert'" class="relative">
      <span fuseAlertTitle>{{errorMessage.message}}</span>
      @for (error of errorMessage.errors; track error) {
        <p>{{error}}</p>
      }
    </fuse-alert>
  }
</div>